module.exports = __webpack_public_path__ + "static/media/reynaldo.4cef23c9.jpg";